module.exports = __webpack_public_path__ + "static/media/calendar.198f8e64.svg";